export class QuestionnaireShort {
  constructor(
    public id: string,
    public title: string,
    public description: string
  ) {}
}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/model/questionnaire-short.ts